import * as React from 'react';
import { useRouteMatch } from 'react-router';
import { Redirect } from 'react-router-dom';

import { PrivateRoute } from '~/components/Auth';
import { MobileHome } from '~/scenes/MobileViews/MobileHome';

export const MobileViewRouter = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <PrivateRoute path={`${path}/home`} component={MobileHome} />
      <PrivateRoute
        exact
        path={path}
        render={() => <Redirect to={`${path}/${'home'}`} />}
      />
    </>
  );
};
